/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { Newsletters } from "App/IOC/Services";

export default Newsletters;
